/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

export const CLICK_LISTENER_OPTIONS = Object.freeze({
    capture: true,
    passive: false,
});

/**
 * Determine if the element you clicked is within another element (the parent or alternateParent)
 *
 * -- Body
 * ------ Header
 * ---------- Tiles
 * -------------- Account Tile
 * ------------------ Switch Role Link (alternateParent)
 * ---------------------- Switch Role Text (what was clicked)
 * ------------------ Switch Role Submenu (parent)
 *
 * The parent of "Switch Role Text" is "Switch Role Link". Our click is within one of our desired elements.
 * None of its parents are the Submenu though. So it fails the check for the "parent". But it passes the check for "alternateParent".
 *
 * @param {object} props
 * @param {React.Ref} props.event - the event that contains the element was the clicked (the target)
 * @param {React.Ref} props.parent - a reference to the element you want to check you are inside
 * @param {React.ReactNode} props.alternateParent - a second element you want to check that you are inside
 * @returns {boolean} true if the element clicked is within the parent OR the alternateParent
 */
const isClickInside = ({ event, parent, alternateParent }) => {
    let element = event.target;

    // Loop through the parents of the element you clicked until you reach the desired element want to be inside
    while (element && element !== parent) {
        element = element.parentNode;
    }

    if (element === parent) {
        // You reached the parent element, your click was inside the parent
        return true;
    } else {
        // First check failed, now try the same thing but with the alternateParent
        element = event.target;

        // Loop through the parents of the element you clicked until you reach the desired element want to be inside
        while (element && element !== alternateParent) {
            element = element.parentNode;
        }

        // If this is false, that means the click is not within the parent or the alternateParent
        return element === alternateParent;
    }
};

export default isClickInside;